function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}

jQuery(document).ready(function() {
  jQuery(".vd_play_btn").click(function() {
    jQuery(".product_video_wrapper video").trigger('play');
    jQuery(this).addClass('d-none');
  });
  jQuery(".product_video_wrapper video").trigger('pause');
  jQuery(".product_video_wrapper video").click(function() {
    jQuery(this).trigger('pause');
    jQuery(".vd_play_btn").removeClass('d-none');
  });
  
  jQuery(".shipping_dropdown_wrapper select option").click(function(){
  	
  }); 

  $(".shipping_dropdown_wrapper select").change(function(){
    window.open("https://www.raysjewellery.com/pages/shipping-policy-european-shipping");
  });
//   $('.countrypicker').selectpicker();
 
});